<template>
    <div class="monitoring-dynamics-item">
        <UIChanges class="monitoring-dynamics-item__changes" :value="data.changes" />
        <p class="monitoring-dynamics-item__value">
            {{ data.value }}
        </p>
        <p class="monitoring-dynamics-item__name">
            {{ data.name }}
        </p>
    </div>
</template>

<script setup lang="ts">
    import type { MonitoringDynamicsItemProps } from './types.ts'

    const props = defineProps<MonitoringDynamicsItemProps>()

    const data = computed(() => {
        return {
            name: props.data.name,
            value: props.data.value,
            changes: props.data.changes
        }
    })
</script>

<style lang="scss" scoped>
    .monitoring-dynamics-item {
        position: relative;
        display: flex;
        justify-content: space-between;
        flex-flow: column;
        padding: 16px;

        @include respond-to(mobile) {
            justify-content: flex-start;
            flex-flow: row wrap;
            padding: 12px;
        }

        &__name {
            font-family: var(--accent-font);
            font-size: 12px;
            line-height: 1.2;
            color: var(--grey-400);

            @include respond-to(mobile) {
                order: 2;
                width: 100%;
            }
        }

        &__value {
            margin-top: 24px;
            margin-bottom: 8px;
            font-family: var(--accent-font);
            font-size: 24px;
            font-weight: 600;
            line-height: 1;

            @include respond-to(mobile) {
                order: 0;
                margin-top: 0;
                margin-right: 8px;
            }
        }

        &__changes {
            align-self: end;

            @include respond-to(mobile) {
                align-self: start;
                order: 1;
            }
        }
    }
</style>
